import { cn } from '@/shared/lib/cn'
import s from './Skeleton.module.css'

type SkeletonProps = {
  width: number | string
  height: number | string
  radius: number | string
  className?: string
}

export function Skeleton({ width, height, radius, className }: SkeletonProps) {
  return (
    <div
      className={cn(s.root, className)}
      style={{ width, height, borderRadius: radius }}
      aria-hidden="true"
    />
  )
}
